import { FundingProjects } from "./components";

export default FundingProjects;
